<div>
  <div class="title">
    <h2 class="primary" i18n="@@Rename Project Folder">Rename Project Folder</h2>
  </div>
  <div>
    <form [formGroup]="changeForm" (change)="formChanged()">
      <!--
        The label used to carry `i18n="@@Parent folder"` while its
        source text read "Current folder". The id is the only key the
        translation bundles use, so every locale — English included —
        rendered "Parent folder" here, which is the wrong relationship:
        this dialog renames THIS folder, it does not act on its parent.
      -->
      <app-folder-path [path]="selectedFolder"><ng-container i18n="@@Current folder">Current folder</ng-container></app-folder-path>
      <div class="text-inside">
        <mat-form-field class="full-width">
          <mat-label i18n="@@Folder Name">Folder Name</mat-label>
          <input formControlName="newFolderName" matInput i18n-placeholder="@@Folder Name" placeholder="Folder Name" type="text" name="first-name" (input)="update()" (blur)="update()" required/>
        </mat-form-field>
      </div>
      <div class="folderError" *ngIf="errorMessage" i18n="@@A folder with that name already exists here.">A folder with that name already exists here.</div>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button type="submit" color="primary" class="Update-btn" [disabled]="changeForm.invalid || Util.getLastItem(selectedFolder, '/') === newFolderName" [title]="folderNameLabel" (click)="onChange()">{{ 'Rename Folder To' | languageString }}<ng-container *ngIf="folderNameLabel">&nbsp;"{{ folderNameLabel }}"</ng-container></button>
      </div>
    </form>
  </div>
</div>
